// Bookie · Qora Tosh — 50th milestone birthday gala variant. The
// standalone HTML template lives at /templates/bookie-onyx.html
// (Bookie phone-shell, DARK shell variant: onyx black #14110D base +
// dusty rose #C9869B accent + champagne gold #D4B26A reserved for the
// dramatic hero "50" numeral + paper #F5EFE6 body text, Italiana
// display + Cormorant Garamond italic body + Manrope UI). Section
// flow: HERO (giant gold "50" + name) → INVITATION → PHOTO TIMELINE
// (six decades 1976→2026 with year captions) → TRIBUTE WALL (4 quote
// cards) → DRESS CODE (Black Tie) → DETAILS → RSVP → CLOSING.
//
// Mocks shape: names = "Celebrant · Age yosh" (single celebrant + age
// with a middot separator — milestone birthday, no ampersand). The
// customizer inside the HTML splits on middot/dot/comma and pulls the
// numeric age out of the second segment. Music kept on (gala
// atmosphere). Reveal-on-scroll kept.
//
// Payload values are passed via URL because postMessage races the
// iframe's first paint and the customizer must run before the
// IntersectionObserver inside the HTML attaches.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-onyx.html";

export function BookieOnyxStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) {
    // Convert dd.mm.yyyy → ISO yyyy-mm-dd for the customizer.
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Demo / preview surfaces leave ctx.slug undefined.
  if (ctx.slug) params.set("slug", ctx.slug);
  if (t.musicTrackId) params.set("audio", "/music/" + t.musicTrackId + ".mp3");
  // Gala music — kept on for this celebration template. Audio src
  // still flows through the ?audio= URL param like other variants.
  // Cache buster — bump when the static HTML changes.
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Qora Tosh"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#14110D",
      }}
    />
  );
}
